import React from "react";
import { connect } from "react-redux";

import "./styles/Dashboard.scss";
import { colors } from "../constants";
import { logout } from "../actions/auth";
import { ColorCard } from "../components/Card";

class Dashboard extends React.Component {
  logout = () => {
    this.props.logout();
    this.props.history.push("/");
  };

  render() {
    const { email } = this.props.userData.account || {};
    const { Earned, NumAccepted, CurrentPackages } =
      this.props.userData.merchant || {};

    return (
      <div
        id="dashboardView"
        style={{ backgroundColor: colors.backgroundBlue }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between"
          }}
        >
          <h2 className="pageHeader">Profile</h2>
          <button className="logoutButton" onClick={this.logout}>
            LOGOUT
          </button>
        </div>

        <div style={{ width: "100%" }}>
          <h5 className="subHeader">Email</h5>
          <span>{email}</span>
        </div>

        <ColorCard title="Monthly Summary" color={colors.lightBlue}>
          <div className="rowItem">
            <img src={require("../assets/icons/box.png")} alt="box" />
            <p>{NumAccepted} Packages accepted</p>
          </div>
          <div className="rowItem">
            <img src={require("../assets/icons/money.png")} alt="money" />
            <p>${Earned} Earned</p>
          </div>
        </ColorCard>

        <ColorCard
          title="Inventory"
          subtitle={`${CurrentPackages.length} packages in stock`}
          color={colors.lightGrey}
        />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(logout())
});

const mapStateToProps = state => ({
  ...state
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Dashboard);
